var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarAtivarDesativarUsuario()}}},[_vm._v(_vm._s(_vm.operacaoBtn)+" Usuário")])}
var staticRenderFns = []

export { render, staticRenderFns }